import React from 'react';

export default function RootPlaceholder() {
    return (
        <main className="container min-vh-100 d-flex align-items-center justify-content-center">
            <section className="text-center">
                <h1>Esmeralda Nava</h1>

            </section>
        </main>
    );
}
